<input
    type="text"
    class="form-control mb-3"
    placeholder="Type to filter the name column..."
    (keyup)="updateFilter($event)"
/>
<ngx-datatable
    #table
    [columns]="columns"
    columnMode="force"
    [headerHeight]="50"
    [footerHeight]="50"
    rowHeight="auto"
    [limit]="10"
    [rows]="rows"
>
</ngx-datatable>